<div class="container">
  <div class="tabs" style="margin-bottom: 3px" [hidden]="!tabbed">
    <div class="tab" id="tab_customerInformationContainer">
      <div
        class="content"
        (click)="selectBookmark('customerInformationContainer')"
      >
        Customer Info
      </div>
    </div>
    <div class="tab" id="tab_paymentMethodsContainer">
      <div class="content" (click)="selectBookmark('paymentMethodsContainer')">
        Payment Methods
      </div>
    </div>
    <div class="tab" id="tab_recurringContainer">
      <div class="content" (click)="selectBookmark('recurringContainer')">
        Recurring Schedules
      </div>
    </div>
    <div class="tab" id="tab_transactionsContainer">
      <div class="content" (click)="selectBookmark('transactionsContainer')">
        Transactions
      </div>
    </div>
    <div class="endspace"></div>
  </div>

  <div
    class="sectionContainer tabContent paddedContent containerMargins"
    style="border-top-left-radius: 0px"
    id="customerInformationContainer"
  >
    <div style="width: 98%">
      <!-- for some reason if the width is wider than this, we got horizontal scrollbars -->

      <app-customer-info
        [customer]="customer"
        [enableEditing]="true"
      ></app-customer-info>
    </div>
  </div>

  <div
    class="sectionContainer tabContent paddedContent containerMargins"
    style="border-top-left-radius: 0px"
    id="paymentMethodsContainer"
  >
    @if (customer.id && customer.paymentMethods != null) {
      <app-payment-methods
        [paymentMethods]="customer.paymentMethods"
        [customerId]="customer.id"
        [merchantId]="customer.merchantId"
      ></app-payment-methods>
    }
  </div>

  <div
    class="sectionContainer tabContent paddedContent containerMargins"
    style="border-top-left-radius: 0px"
    id="recurringContainer"
  ></div>

  <div
    class="sectionContainer tabContent paddedContent containerMargins"
    style="border-top-left-radius: 0px"
    id="transactionsContainer"
  >
    <app-customer-transactions
      [customerId]="customer.id"
    ></app-customer-transactions>
  </div>
</div>
